export default "__VITE_ASSET__c1a738e4__"